import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import { Container } from 'react-bootstrap';
import classes from "./Layout.module.css";
import Aux from '../../hoc/Aux';

const Layout = (props) => {

  return (
    <Aux>
      <Container className={[classes.Container, "p-3"]}>
        {props.children}
      </Container>
    </Aux>
  )

}

export default Layout;